import { useContext } from 'react';
import APIContext from './context';

export default function useAPI() {
  return useContext(APIContext);
}
